import { render, staticRenderFns } from "./Whitelabel.vue?vue&type=template&id=2c683ab4"
import script from "./Whitelabel.vue?vue&type=script&lang=js"
export * from "./Whitelabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports